import React from "react";
import "./Howitworks.css";

const steps = [
  { title: "Capture", icon: "https://cdn-icons-png.flaticon.com/512/685/685655.png" },
  { title: "Analyze", icon: "https://cdn-icons-png.flaticon.com/512/942/942748.png" },
  { title: "Assign", icon: "https://cdn-icons-png.flaticon.com/512/1048/1048318.png" },
  { title: "Clean", icon: "https://cdn-icons-png.flaticon.com/512/809/809957.png" }
];

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <div className="container">
        <h3 className="section-title">How It Works</h3>

        <div className="steps-wrapper">
          {steps.map((item, index) => (
            <div className="step-card" key={index}>
              <img src={item.icon} alt={item.title} className="step-icon" />
              <h6 className="step-title">{item.title}</h6>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
